document.addEventListener('DOMContentLoaded', () => {
    const dialogLanguageSelection = document.querySelector('.js-dialog-language-selection');

    if (dialogLanguageSelection && !localStorage.getItem('poi__selected_language')) {
        if (dialogLanguageSelection.dialog) {
            dialogLanguageSelection.dialog.open();

            const dialogLanguageSelectionItems = Array.from(
                document.querySelectorAll('.js-dialog-language-selection-item'),
            );

            dialogLanguageSelectionItems.forEach((item) => {
                item.addEventListener('click', () => {
                    localStorage.setItem('poi__selected_language', item.dataset.lng);
                    dialogLanguageSelection.dialog.close();
                });
            });
        }
    }
});
